// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1CM8k","title":"Info_title__2IgIN","selects":"Info_selects__1G63j","requiredAsterisk":"Info_requiredAsterisk__2uco6"};